var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBitget(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_331_2144)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.51119 4.28055C7.66103 4.09819 7.87603 4 8.09754 4H9.53083C9.6481 4.00701 9.74583 4.11222 9.73931 4.23847C9.73931 4.29458 9.71977 4.34367 9.68068 4.38576L6.84014 7.78042H8.40374L9.99991 9.67413H6.84014L9.99991 13.4545H8.09102C7.86951 13.4545 7.65452 13.3564 7.50467 13.174L4.30581 9.33046C4.01916 8.98678 4.01916 8.46075 4.30581 8.11708L7.51119 4.28055Z",
    fill: "#F0B90B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4925 16.7192C12.3428 16.9017 12.1281 17 11.9068 17H10.4751C10.3579 16.9929 10.2603 16.8877 10.2668 16.7613C10.2668 16.7052 10.2863 16.656 10.3254 16.6139L13.1563 13.2167H11.5944L10 11.3286H13.1563L10 7.54541H11.9068C12.1281 7.54541 12.3428 7.65069 12.4925 7.82617L15.6943 11.6655C15.9807 12.0095 15.9807 12.5359 15.6943 12.8798L12.4925 16.7192Z",
    fill: "#F0B90B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_331_2144"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F0B90B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitget);
export default __webpack_public_path__ + "static/media/bitget.156b20a8ee9ceabf3a022925b36ca4fb.svg";
export { ForwardRef as ReactComponent };